import React, { useContext, useEffect, useState } from "react";
import classNames from "classnames";

import { QRFeedbackContext } from "@/contexts/QRFeedbackContext";

import { StarsRatingProps } from "./types";
import { QRFeedbackContextProps } from "@/contexts/QRFeedbackContext/types";

import "./styles.scss";

export const StarsRating = ({ itemIndex = 0, defaultCheckedValue, compact }: StarsRatingProps) => {
  const qrFeedbackContextData = useContext<QRFeedbackContextProps>(QRFeedbackContext);
  const { setRatingSelected } = qrFeedbackContextData;

  const [selectedRating, setSelectedRating] = useState(defaultCheckedValue);

  useEffect(() => {
    setSelectedRating(defaultCheckedValue);
  }, [defaultCheckedValue]);

  const radioButtonsArr = Array.from({ length: 5 }, (_, i) => i + 1).reverse();
  const classnames = classNames("starsRating-container", {
    [`compact`]: compact,
  });

  return (
    <div className={classnames}>
      <div className="starsRating-feedback">
        <div
          className="rating"
          id={`rating-${itemIndex}`}
        >
          {radioButtonsArr.map((item) => {
            const id = `rating-${item}-${itemIndex}`;
            return (
              <React.Fragment key={id}>
                <input
                  type="radio"
                  name={`rating-${itemIndex}`}
                  id={id}
                  value={item}
                  checked={selectedRating === item}
                  disabled={compact}
                  onChange={(e) => {
                    if (compact) return;
                    const value = Number(e.target.value);
                    setSelectedRating(value);
                    setRatingSelected(value);
                  }}
                />
                <label htmlFor={id}></label>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StarsRating;
